"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ethEnsNamehash = require("eth-ens-namehash");

var _web3Utils = require("web3-utils");

var _FDSENS = _interopRequireDefault(require("./FDS-ENS2.js"));

var _FDSMailbox = _interopRequireDefault(require("./FDS-Mailbox.js"));

var _FDSSwarm = _interopRequireDefault(require("./FDS-Swarm.js"));

var _FDSSwarmFeeds = _interopRequireDefault(require("./FDS-SwarmFeeds.js"));

var _FDSCrypto = _interopRequireDefault(require("./FDS-Crypto.js"));

var _Message = _interopRequireDefault(require("./models/Message.js"));

var _Hash = _interopRequireDefault(require("./models/Hash.js"));

var _Contact = _interopRequireDefault(require("./models/Contact.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

class Mail {
  constructor(config, account) {
    this.account = account;
    this.config = config;
    this.Mailbox = new _FDSMailbox.default(config);
    this.Store = new _FDSSwarm.default(config, account);
    this.SF = new _FDSSwarmFeeds.default(config);
    this.SwarmStore = this.account.SwarmStore;
  } //
  //

  /**
   * @sendFileTo
   * TODO: later will replace callbacks with emitted events...
   * @param {any} senderAccount account
   * @param {any} recipientSubdomain name
   * @param {any} file to send
   * @param {any} encryptProgressCallback callback
   * @param {any} uploadProgressCallback callback
   * @param {any} progressMessageCallback callback
   * @returns {any} success
   */


  lookupContact(senderAccount, recipientSubdomain) {
    var ENS = new _FDSENS.default(senderAccount, this.config.ensConfig);
    var multiboxAddress, recipientPublicKey; // let senderSubdomainNameHash = hash(senderAccount.subdomain + '.' + this.config.ensConfig.domain);

    var recipientSubdomainNameHash = (0, _ethEnsNamehash.hash)(recipientSubdomain + '.' + this.config.ensConfig.domain);
    var feedLocationHash = this.Mailbox.encodeFeedLocationHash(senderAccount.address, recipientSubdomainNameHash); //get public key
    // progressMessageCallback(`retrieving public key`);

    return ENS.getPubKey(recipientSubdomain).then(publicKey => {
      //calculate shared secret
      recipientPublicKey = '0x' + publicKey.substr(2, 130); // let sharedSecret = Crypto.calculateSharedSecret(senderAccount.privateKey, publicKey);
      // return sharedSecret;
      //retrieve multihash
    }).then(secret => {
      // sharedSecret = secret;
      // progressMessageCallback(`retrieving mailbox address`);
      return ENS.getMultihash(recipientSubdomain); //if multihash
    }).then(hash => {
      multiboxAddress = hash; // progressMessageCallback(`retrieving connection`);

      if (multiboxAddress === '0x') {
        throw Error('could not find multihash entry');
      }
    }).then(request => {
      return new _Contact.default({
        subdomain: recipientSubdomain,
        publicKey: recipientPublicKey,
        multiboxAddress: multiboxAddress,
        feedLocationHash: feedLocationHash
      });
    });
  } //
  //

  /**
   * @sendFileTo
   * TODO: later will replace callbacks with emitted events...
   * @param {any} senderAccount account
   * @param {any} recipientSubdomain name
   * @param {any} file to send
   * @param {any} encryptProgressCallback callback
   * @param {any} uploadProgressCallback callback
   * @param {any} progressMessageCallback callback
   * @returns {any} success
   */


  send(senderAccount, recipientSubdomain, file, multiboxPath) {
    var encryptProgressCallback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : console.log;
    var uploadProgressCallback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : console.log;
    var progressMessageCallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : console.log;
    var ENS = new _FDSENS.default(senderAccount, this.config.ensConfig); //get public key from repo

    var sharedSecret, multiboxAddress, recipientPublicKey, message;
    var senderSubdomainNameHash = (0, _ethEnsNamehash.hash)(senderAccount.subdomain + '.' + this.config.ensConfig.domain);
    var recipientSubdomainNameHash = (0, _ethEnsNamehash.hash)(recipientSubdomain + '.' + this.config.ensConfig.domain);
    var feedLocationHash = this.Mailbox.encodeFeedLocationHash(senderAccount.address, recipientSubdomainNameHash); //get public key

    progressMessageCallback("retrieving public key");
    return ENS.getPubKey(recipientSubdomain).then(publicKey => {
      //calculate shared secret
      recipientPublicKey = publicKey;

      var sharedSecret = _FDSCrypto.default.calculateSharedSecret(senderAccount.privateKey, publicKey);

      return sharedSecret; //retrieve multihash
    }).then(secret => {
      sharedSecret = secret;
      progressMessageCallback("retrieving mailbox address");
      return ENS.getMultihash(recipientSubdomain); //if multihash
    }).then(hash => {
      multiboxAddress = hash;
      progressMessageCallback("retrieving connection");

      if (multiboxAddress !== '0x') {
        return this.Mailbox.getInboxFeed(senderAccount, senderAccount.subdomain, multiboxAddress, multiboxPath);
      } else {
        throw Error('could not find multihash entry');
      }
    }).then(request => {
      //create a new request
      if (JSON.stringify(request.values) === JSON.stringify({}) || request.values[senderSubdomainNameHash] === undefined) {
        progressMessageCallback("creating connection ".concat(senderAccount.subdomain, "->").concat(recipientSubdomain));
        return this.Mailbox.newInboxFeed(senderAccount, senderAccount.subdomain, senderSubdomainNameHash, multiboxAddress, feedLocationHash, multiboxPath).then(request => {
          return senderAccount.storeContact(new _Contact.default({
            subdomain: recipientSubdomain,
            publicKey: recipientPublicKey,
            multiboxAddress: multiboxAddress,
            feedLocationHash: feedLocationHash
          }));
        }).then(() => {
          var flh = this.Mailbox.decodeFeedLocationHash(feedLocationHash);
          return this.initMessages(recipientPublicKey, senderAccount, flh.topic);
        });
      } else {
        //if there's a request, do nothing
        progressMessageCallback("request found");
        return true;
      }
    }).then(() => {
      //store encrypted file
      progressMessageCallback("storing encrypted file");
      return this.Store.storeEncryptedFile(file, '0x' + sharedSecret, encryptProgressCallback, uploadProgressCallback, progressMessageCallback);
    }).then(storedFilehash => {
      //send the resulting hash to the recipient
      progressMessageCallback("sending encrypted message");
      var feedLocation = this.Mailbox.decodeFeedLocationHash(feedLocationHash);
      message = new _Message.default({
        to: recipientSubdomain,
        from: senderAccount.subdomain,
        hash: storedFilehash
      }, this.config, senderAccount);
      return this.saveMessage(recipientPublicKey, senderAccount, feedLocation.topic, message, multiboxPath, progressMessageCallback);
    }).then(() => {
      return message;
    });
  }
  /**
   * Receive
   * @param {any} recipientAccount account
   * @param {any} message message
   * @param {any} decryptProgressCallback callback
   * @param {any} downloadProgressCallback callback
   * @returns {any} stored file
   */


  receive(recipientAccount, message) {
    var decryptProgressCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console.log;
    var downloadProgressCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : console.log;
    //get public key from repo
    var ENS = new _FDSENS.default(recipientAccount, this.config.ensConfig);
    return ENS.getPubKey(message.from).then(senderPublicKey => {
      //calculate shared secret
      var sharedSecret = _FDSCrypto.default.calculateSharedSecret(recipientAccount.privateKey, senderPublicKey);

      return '0x' + sharedSecret;
    }).then(sharedSecret => {
      //encrypt and upload to store
      var storedFile = this.Store.getDecryptedFile(message.hash, sharedSecret, decryptProgressCallback, downloadProgressCallback);
      return storedFile;
    });
  }
  /**
   * Retrieves sent file
   * @param {any} recipientAccount account
   * @param {any} message message
   * @param {any} decryptProgressCallback callback
   * @param {any} downloadProgressCallback callback
   * @returns {any} stored file
   */


  retrieveSent(recipientAccount, message) {
    var decryptProgressCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console.log;
    var downloadProgressCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : console.log;
    //get public key from repo
    var ENS = new _FDSENS.default(recipientAccount, this.config.ensConfig);
    return ENS.getPubKey(message.to).then(recipientPublicKey => {
      //calculate shared secret
      var sharedSecret = _FDSCrypto.default.calculateSharedSecret(recipientAccount.privateKey, recipientPublicKey);

      return '0x' + sharedSecret;
    }).then(sharedSecret => {
      //encrypt and upload to store
      var storedFile = this.Store.getDecryptedFile(message.hash, sharedSecret, decryptProgressCallback, downloadProgressCallback);
      return storedFile;
    });
  } // ...

  /**
   * Initialize messages
   * @param {any} recipientPublicKey public key
   * @param {any} senderAccount account
   * @param {any} topic name
   * @returns {any} hash
   */


  initMessages(recipientPublicKey, senderAccount, topic) {
    var sharedSecret = _FDSCrypto.default.calculateSharedSecret(senderAccount.privateKey, recipientPublicKey);

    return this.SwarmStore.storeEncryptedValue(topic, JSON.stringify({
      messages: []
    }), senderAccount, '0x' + sharedSecret);
  }
  /**
   * Save message
   * @param {any} recipientPublicKey public key
   * @param {any} senderAccount account
   * @param {any} topic name
   * @param {any} message to save
   * @param {any} progressMessageCallback callback
   * @returns {any} hash
   */


  saveMessage(recipientPublicKey, senderAccount, topic, message, multiboxPath) {
    var progressMessageCallback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : console.log;
    progressMessageCallback("retrieving connection message feed");
    return this.getAccountMessages(recipientPublicKey, senderAccount, topic, multiboxPath).then(messages => {
      progressMessageCallback("saving message feed");
      messages.push(message.toJSON());
      progressMessageCallback("appending message");

      var sharedSecret = _FDSCrypto.default.calculateSharedSecret(senderAccount.privateKey, recipientPublicKey);

      return this.SwarmStore.storeEncryptedValue(topic, JSON.stringify({
        messages: messages
      }), senderAccount, '0x' + sharedSecret);
    });
  }
  /**
   * Get account messages
   * @param {any} recipientPublicKey public key
   * @param {any} senderAccount account
   * @param {any} topic name
   * @returns {any} array of messages
   */


  getAccountMessages(recipientPublicKey, senderAccount, topic, multiboxPath) {
    return this.getMessageFeed(recipientPublicKey, senderAccount.address, senderAccount, topic, multiboxPath);
  }
  /**
   * Get messages
   * @param {any} type of messages, received or sent, received default
   * @param {any} account account
   * @returns {any} array of messages
   */


  getMessages() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'received';
    var account = arguments.length > 1 ? arguments[1] : undefined;
    var path = arguments.length > 2 ? arguments[2] : undefined;

    switch (type) {
      case 'received':
        return this.getReceivedMessages(account, path);

      case 'sent':
        return this.getSentMessages(account, path);
    }
  }
  /**
   * Get received messages
   * @param {any} recipientAccount account
   * @returns {any} array of messages
   */


  getReceivedMessages(recipientAccount, multiboxPath) {
    var ENS = new _FDSENS.default(recipientAccount, this.config.ensConfig);
    return this.getSenders(recipientAccount, multiboxPath).then(senders => {
      var feedPromises = [];

      for (var i = senders.length - 1; i >= 0; i--) {
        feedPromises.push(new Promise((resolve, reject) => {
          var feedLocation = this.Mailbox.decodeFeedLocationHash(senders[i].feedLocationHash);
          return ENS.getPubKeyRaw(senders[i].senderNamehash).then(publicKey => {
            return this.getMessageFeed(publicKey, feedLocation.address, recipientAccount, feedLocation.topic, multiboxPath).then(resolve);
          });
        }));
      }

      return Promise.all(feedPromises).then(messageFeeds => {
        return [].concat.apply([], messageFeeds).sort((a, b) => {
          return a.hash.time > b.hash.time ? 1 : -1;
        });
      });
    });
  }
  /**
   * Get send messages
   * @param {any} recipientAccount account
   * @returns {any} array of messages
   */


  getSentMessages(recipientAccount, multiboxPath) {
    return recipientAccount.getContacts().then(contacts => {
      var feedPromises = [];

      for (var i = contacts.length - 1; i >= 0; i--) {
        feedPromises.push(new Promise((resolve, reject) => {
          var feedLocation = this.Mailbox.decodeFeedLocationHash(contacts[i].feedLocationHash);
          return this.getMessageFeed(contacts[i].publicKey, feedLocation.address, recipientAccount, feedLocation.topic, multiboxPath).then(resolve);
        }));
      }

      return Promise.all(feedPromises).then(messageFeeds => {
        //just concatenating the messages for now, later we'll be more clever with retrieval...
        return [].concat.apply([], messageFeeds).sort((a, b) => {
          return a.hash.time > b.hash.time ? 1 : -1;
        });
      });
    });
  }
  /**
   * Get message feed
   * @param {any} publicKey public key
   * @param {any} address address
   * @param {any} account account
   * @param {any} topic name
   * @returns {any} messages with hash objects
   */


  getMessageFeed(publicKey, address, account, topic) {
    var sharedSecret = _FDSCrypto.default.calculateSharedSecret(account.privateKey, publicKey);

    return this.SwarmStore.retrieveDecryptedValue(topic, address, '0x' + sharedSecret).then(decryptedManifest => {
      var messageParsed = JSON.parse(decryptedManifest).messages;
      var messageObjects = messageParsed.map(m => new _Message.default(m, this.config, account));
      var messageObjectsWithHashObjects = messageObjects.map(m => {
        m.hash = new _Hash.default(m.hash, this.config);
        return m;
      });
      return messageObjectsWithHashObjects;
    }).catch(error => {
      if ((error === null || error === void 0 ? void 0 : error.status) !== 404) {
        throw new Error(error);
      }

      return [];
    });
  }

  getTreeSenders(tree) {
    var senders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (tree.children && tree.children.length > 0) {
      for (var i = tree.children.length - 1; i >= 0; i--) {
        senders = Object.assign(senders, this.getTreeSenders(tree.children[i]));
      }

      return senders;
    } else {
      senders = Object.assign(senders, tree.values);
      return senders;
    }
  }
  /**
   * Get senders
   * @param {any} recipientAccount account
   * @returns {any} sender and location hashes
   */


  getSenders(recipientAccount, multiboxPath) {
    var _this = this;

    return _asyncToGenerator(function* () {
      var ENS = new _FDSENS.default(recipientAccount, _this.config.ensConfig);
      var multiboxAddress = yield ENS.getMultihash(recipientAccount.subdomain);

      if (multiboxAddress === null) {
        throw new Error("couldn't find mailbox for ".concat(recipientAccount.subdomain));
      }

      var senderTree = yield _this.Mailbox.getInboxFeeds(recipientAccount, multiboxAddress, multiboxPath);

      var senders = _this.getTreeSenders(senderTree);

      var feeds = [];

      for (var senderNamehash of Object.keys(senders)) {
        feeds.push({
          senderNamehash: senderNamehash,
          feedLocationHash: senders[senderNamehash]
        });
      }

      return feeds;
    })();
  }

}

var _default = Mail;
exports.default = _default;
module.exports = exports.default;